<template>
  <v-container fluid>
    <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="itemsPerPage"
        :loading="loading"
        :page.sync="page"
        :search="search"
        class="elevation-1"
        hide-default-footer
        loading-text="Loading"
        sort-by="calories"
        @page-count="pageCount = $event"
    >
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  components: {
  },
  data: () => ({
    search: '',
    loading: false,
    dialog: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 100,
    headers: [
      {text: 'Name', value: 'name.value'},
      {text: 'Description', value: 'name.description'},
    ],
    data: [],
  }),

  created() {
    this.initialize()
  },

  methods: {
    ...mapActions(['setGlobalErrorMessage']),
    initialize() {
      this.loading = true
      this.$http.get("/permission")
          .then(response => {
                this.data = response.data;
              },
              e => this.$store.dispatch('setGlobalErrorMessage', e.response.data))
          .finally(() => {
            this.loading = false
          });
    },
    searchItem(event) {
      this.search = event
    },
  },


};
</script>
<style>

</style>
